module.exports = __webpack_public_path__ + "cb35293c6ddb793854fa3e07ef32bdd7.png";